export default __webpack_public_path__ + "static/media/best_selection.5ef6e834.png";